import { Component, computed, HostBinding, input } from '@angular/core';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-input, [panInput]',
  templateUrl: './pan-input.component.html',
  styleUrl: './pan-input.component.scss',
  standalone: false,
})
export class PanInputComponent {
  public color = input<ThemeColor>('default');
  public disabled = input<boolean>(false);

  @HostBinding('class')
  public get hostClasses() {
    return this.classes().join(' ');
  }

  public classes = computed(() => {
    return ['input', `input-color-${this.color()}`, this.disabled() ? 'input-disabled' : ''];
  });
}
